import { Injectable } from '@angular/core';

import { merge, Observable, tap } from 'rxjs';

import { Reply } from '@shared/reply/models';
import { WebSocketEventsEnum } from '@shared/websocket';
import { ReplyApiService } from './reply-api.service';
import { RepliesQuery, RepliesStore } from './replies-state';
import { SocketService } from '@tablesready/frontend-store';

@Injectable({providedIn: 'root'})
export class ReplyService {
  constructor(
    private readonly apiService: ReplyApiService,
    private readonly query: RepliesQuery,
    private readonly store: RepliesStore,
    private readonly socketService: SocketService,
  ) {
  }

  load(): Observable<Reply[]> {
    return this.apiService.getList()
      .pipe(
        tap(replies => this.store.set(replies)),
      );
  }

  selectAll(): Observable<Reply[]> {
    return this.query.selectAll();
  }

  reset(): void {
    this.store.reset();
  }

  listenToChanges() {
    return merge(
      this.socketService
        .getEventStream<Reply[]>(WebSocketEventsEnum.replyCreated)
        .pipe(tap(reply => this.store.add(reply))),
      this.socketService
        .getEventStream<Reply[]>(WebSocketEventsEnum.replyUpdated)
        .pipe(tap(reply => {
          for (let i = 0; i < reply.length; i++) {
            this.store.update(reply[i].id, reply[i]);
          }
        })),
      this.socketService
        .getEventStream<string[]>(WebSocketEventsEnum.replyDeleted)
        .pipe(tap(ids => this.store.remove(ids))),
    );
  }
}
